module.exports = __webpack_public_path__ + "static/media/mythical-molly.98a5e847.png";